import React, { useState } from "react"
import PropTypes from "prop-types"
import { Grid } from "@chakra-ui/react"

import Section from "./Section"
import SelectedBoat from "./SelectedBoat"
import ContactForm from "./ContactForm"
import ThankYou from "./ThankYou"

const Contact = ({ boat, offer, search, type }) => {
  const [formSubmitted, setFormSubmitted] = useState(false)

  return (
    <Section mt={[12, 16]}>
      <Grid
        sx={{
          gridTemplateColumns: ["1fr", "1fr 1fr"],
          gridRowGap: 5,
          gridColumnGap: 4,

          h2: {
            mb: 3,
            mt: 0,
          },
        }}
      >
        <SelectedBoat boat={boat} offer={offer} type={type} search={search} />
        {formSubmitted ? (
          <ThankYou type={type} />
        ) : (
          <ContactForm boat={boat} offer={offer} search={search} type={type} setFormSubmitted={setFormSubmitted} />
        )}
      </Grid>
    </Section>
  )
}

Contact.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  boat: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  offer: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  search: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
}

export default Contact
